export default __webpack_public_path__ + "static/bloob-dd9bee6c0d68d87ffd037f03d370c80d.mp4";